<template>
  <div class="shadow rounded-1">
    <h2 class="text-center pt-3">Status Penyampaian Laporan Tahunan</h2>
    <apexchart
      type="pie"
      height="398"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['tahun'],
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      series: [44, 55],
      chartOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['Terlambat', 'Tepat Waktu'],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex]
          },
        },
        legend: {
          position: 'bottom',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    }
  },
  methods: {
    async loadDataChart() {
      // try {
      //   const res = await axios.get(
      //     `${this.baseapi}api/dashboard/getJumlahPermohonanKlasifikasi?tahun=${this.tahun}`,
      //     {
      //       headers: {
      //         Authorization: `Bearer ` + this.user.accessToken,
      //       },
      //     }
      //   )
      //   const data = res.data.data
      //   this.series = data.series.map((d) => ({
      //     name: d.name,
      //     data: d.series,
      //   }))
      //   this.chartOptions = {
      //     ...this.chartOptions,
      //     xaxis: {
      //       categories: [...data.categories],
      //     },
      //   }
      // } catch (error) {}
    },
  },
  watch: {
    tahun: {
      handler(val) {
        this.loadDataChart()
      },
      immediate: true,
    },
  },
}
</script>
